import { useLocation } from "react-router-dom";
import queryString from "query-string";

const useQueryString = () => {
	const location = useLocation();
	let url = location.search;
	let params = queryString.parse(url);
	return params;
};
export default useQueryString;
